import { render, staticRenderFns } from "./CustomersComponent.vue?vue&type=template&id=00c73a3f&scoped=true"
import script from "./CustomersComponent.vue?vue&type=script&lang=js"
export * from "./CustomersComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomersComponent.vue?vue&type=style&index=0&id=00c73a3f&prod&scoped=true&lang=css"
import style1 from "./CustomersComponent.vue?vue&type=style&index=1&id=00c73a3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c73a3f",
  null
  
)

export default component.exports